import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ToastController } from "ionic-angular";
import { Observable } from "rxjs/Observable";
import ContentWrapper from "../../models/content-wrapper/content-wrapper";
import Activity from "../../models/patient-chart/activities/activity";
import DisciplineResponse from "../../models/patient-chart/activities/disciplineResponse";
import { ConfigurationService } from "../configuration/configuration.service";

@Injectable()
export class ActivitiesProvider {
  activitiesUrl: string;

  constructor(
    public http: HttpClient,
    private toastCtrl: ToastController,
    private config: ConfigurationService
  ) {
    this.activitiesUrl = config.getConfig().apiUrl;
  }

  /* Return all available activity types */
  activityTypes(): Observable<any> {
    return this.http.get(
      `${this.activitiesUrl}/patient-charts/activities/lookups`
    );
  }

  /* Return all available disciplines by patient chart */
  disciplines(
    patientChartId: number,
    externalId: number
  ): Observable<DisciplineResponse[]> {
    return this.http.get<DisciplineResponse[]>(
      `${this.activitiesUrl}/patient-charts/${patientChartId}/activities/disciplines?externalId=${externalId}`
    );
  }

  getActivities(
    patientChartId: number,
    externalId: number,
    page = 0,
    size = 10,
    orderBy = "desc",
    sortBy = "createdDatetime",
    options = ""
  ): Observable<ContentWrapper<Activity>> {
    console.log(`Grabbing activities @ for patient chart id ${patientChartId}`);
    console.log(
      `${this.activitiesUrl}/patient-charts/${patientChartId}/activities?externalId=${externalId}&page=${page}&limit=${size}&by=${sortBy}&direction=${orderBy}&${options}`
    );
    return this.http.get<ContentWrapper<Activity>>(
      `${this.activitiesUrl}/patient-charts/${patientChartId}/activities?externalId=${externalId}&page=${page}&limit=${size}&by=${sortBy}&direction=${orderBy}&${options}`
    );
  }
}



// WEBPACK FOOTER //
// ./src/providers/patient-charts/activitiesService.ts